import { Icon } from '@chakra-ui/react'
import { RiCloseCircleFill } from 'react-icons/ri'

export const CloseRoundedFilled = props => <Icon as={RiCloseCircleFill} {...props} />
